import { createApp } from "vue";
import axios from "./config/axios/AxiosConfig";
import App from "./App.vue";
import i18n from "./i18n";
import VueGtag from "vue-gtag";
import { getGlobalConfig } from "@/config/globalConfig";

const config = getGlobalConfig();
const app = createApp(App);
app.use(VueGtag, {
  config: {
    id: config.gtmId,
  },
});
app.use(i18n);
app.provide("config", config);
app.config.globalProperties.axios = axios;
app.mount("#costs-calculator-app");
